import _ from "lodash";

import { FieldType } from "prisma/cm/client";

import { DefinitionFieldType } from "./types";
import { PayPointGroupName } from "../pay-points/types";

export function getFieldTypeForPayPointGroup(
  payPointGroupName: PayPointGroupName,
): DefinitionFieldType[] {
  const isEquityColumn = _.includes(
    ["newHireGrant", "promoGrant", "refreshGrant"],
    payPointGroupName,
  );

  if (isEquityColumn) {
    return ["EQUITY"];
  }

  if (_.includes(["salary", "totalPay", "variable"], payPointGroupName)) {
    return [FieldType.DOLLAR];
  }

  if (payPointGroupName === "bonus") {
    return [FieldType.PERCENT];
  }

  return [];
}
